import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import axios from "axios";
import { set_page_refresh } from "../../redux/action";
import countriesData from "../../json/countries.json";
import paymentMethodsData from "../../json/paymentMethods.json"; // Import the payment methods JSON
import { APIgetStores } from "../../../api/settings.ts";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";


const AddPaymentGateWays = () => {
  const dispatch = useDispatch();
 
  const MySwal = withReactContent(Swal);
  const [availablePaymentMethods, setAvailablePaymentMethods] = useState([]); // New state for available payment methods
  const [validationErrors, setValidationErrors] = useState({});
  const data = useSelector((state) => state.gateway_edit);
  const closeRef = useRef(null);
  const [showStripeFields, setShowStripeFields] = useState(false);
  const [showBankFields, setShowBankFields] = useState(false);
  const [dataStore, setDataStore] = useState([]);
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const storeOptions = [
    // { value: '', label: 'Select Store' }, // Default option
    ...dataStore.map(store => ({
      value: store.value,
      label: store.label
    }))
  ];
  
  const [paymentGateWays, setPaymentGateWays] = useState({
    _id: "",
    country: "",
    stores: [],
    paymentMethods: [], // List of selected payment methods
    paymentDetails: [], // List of payment details per method
      stripeApiKey: "",
      stripeSecretKey: "",
      bankName: "",
      accountHolderName: "",
      accountNumber: "",
      iban: ""
  });

  const countriesOptions = [
    { value: "select_country", label: "Select Country", name: "Select Country" },
    ...countriesData.map(country => ({
        value: country.name,
        label: t?.[l]?.[country.name] || country.name
    }))
];
  useEffect(() => {
    if (data && Object.keys(data).length) {
      setPaymentGateWays({
        _id: data._id,
        country: data.country,
        stores: data.stores || [],
        paymentMethods: data.paymentMethods || [],
        paymentDetails: data.paymentDetails || [],
        stripeApiKey: data.paymentDetails?.find(detail => detail.paymentType === "stripe")?.stripeApiKey || "",
        stripeSecretKey: data.paymentDetails?.find(detail => detail.paymentType === "stripe")?.stripeSecretKey || "",
        bankName: data.paymentDetails?.find(detail => detail.paymentType === "banktransfer")?.bankName || "",
        accountHolderName: data.paymentDetails?.find(detail => detail.paymentType === "banktransfer")?.accountHolderName || "",
        accountNumber: data.paymentDetails?.find(detail => detail.paymentType === "banktransfer")?.accountNumber || "",
        iban: data.paymentDetails?.find(detail => detail.paymentType === "banktransfer")?.iban || "",

      });
      if(data.paymentDetails?.find(detail => detail.paymentType === "stripe"))
        setShowStripeFields(true);
      if(data.paymentDetails?.find(detail => detail.paymentType === "banktransfer"))
        setShowBankFields(true);
      
      setAvailablePaymentMethods(paymentMethodsData[data.country] || []); // Set payment methods based on the country
    } else {
      resetForm();
    }
  }, [data]);

  useEffect(() => {
    const handleHidden = () => {
      // Reset the form state when the modal is hidden
      resetForm();
    };

    const modalElement = document.getElementById('add-brand');
    modalElement?.addEventListener('hidden.bs.modal', handleHidden);

    return () => {
      modalElement?.removeEventListener('hidden.bs.modal', handleHidden);
    };
  }, []);


  const resetForm = () => {
    setPaymentGateWays({
      _id: "",
      country: "",
      stores: [],
      paymentMethods: [],
      paymentDetails: [],

        stripeApiKey: "",
        stripeSecretKey: "",
        bankName: "",
        accountHolderName: "",
        accountNumber: "",
        iban: "",

    });
    setShowBankFields(false)
    setShowStripeFields(false)
    setAvailablePaymentMethods([]); // Reset available payment methods
  };

  useEffect(() => {
    getStoreApi();
  }, []);

  const getStoreApi = async () => {
    const res = await APIgetStores({});
    if (res?.response?.stores) {
      const storeData = res.response.stores.reverse();
      console.log("storeData", storeData);
      const storeOptions = storeData.map((store) => ({
        label: store.title,// "(" + store.storeNumber + ")", // storeNumber
        value: store._id,
        storeCode: store.storeNumber, // Store code
      }));
      setDataStore(storeOptions);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "country") {
      setPaymentGateWays((prevState) => ({
        ...prevState,
        country: value, // Update country
        paymentMethods: [], // Reset payment methods
        paymentDetails: [],

        stripeApiKey: "",
        stripeSecretKey: "",
        bankName: "",
        accountHolderName: "",
        accountNumber: "",
        iban: "",

      }));
      setAvailablePaymentMethods(paymentMethodsData[value] || []); // Set payment methods based on the selected country
    } else if (name === "storeId") {
      // eslint-disable-next-line no-debugger
      debugger;
      const selectedStores = value.map((id) => {
        const store = dataStore.find((s) => s.value == id);
        return store ? { storeId: id, storeCode: store.storeCode, storeName: store.label } : null;
      }).filter(Boolean); // Filter out any null values
    
      console.log("selectedStores", selectedStores);
    
      setPaymentGateWays((prevState) => ({
        ...prevState,
        stores: selectedStores,
      }));
    }
    else {
      setPaymentGateWays((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const verifyStripeKeys = async (apiKey, secretKey) => {
    try {
       
        // Verify the secret key
        const secretResponse = await axios.get('https://api.stripe.com/v1/accounts', {
            headers: { Authorization: `Bearer ${secretKey}` },
        });


        // Check the responses
        return (
            // apiResponse.status === 200 &&
            secretResponse.status === 200 
        );
    } catch (error) {
        console.error("Invalid Stripe keys or error creating account:", error);
        return false;
    }
};

const handleCheckboxChange = (method, isChecked) => {
  setPaymentGateWays((prevState) => {
    const updatedMethods = isChecked
      ? [...prevState.paymentMethods, method] // Add method
      : prevState.paymentMethods.filter((m) => m !== method); // Remove method

      paymentGateWays.paymentDetails = paymentGateWays.paymentDetails?.filter(
        detail => detail.paymentType !== method
      );

    return {
      ...prevState,
      paymentMethods: updatedMethods,
    };
  });
};


const validateForm = () => {
  const errors = {};

  if (!paymentGateWays.country || paymentGateWays.country === "select_country") {
    errors.country = "Country is required.";
  }

  if (paymentGateWays.stores.length === 0) {
    errors.stores = "At least one store must be selected.";
  }

  if (paymentGateWays.paymentMethods.length === 0) {
    errors.paymentMethods = "At least one payment method must be selected.";
  }

  if (showStripeFields) {
    const stripe = paymentGateWays.paymentDetails.find((detail) => detail.paymentType === "stripe");
    if (!stripe?.stripeApiKey) {
      errors.stripeApiKey = "Stripe API Key is required.";
    }
    if (!stripe?.stripeSecretKey) {
      errors.stripeSecretKey = "Stripe Secret Key is required.";
    }
  }

  if (showBankFields) {
    const bank = paymentGateWays.paymentDetails.find((detail) => detail.paymentType === "banktransfer");
    if (!bank?.bankName) {
      errors.bankName = "Bank Name is required.";
    }
    if (!bank?.accountHolderName) {
      errors.accountHolderName = "Account Holder Name is required.";
    }
    if (!bank?.accountNumber) {
      errors.accountNumber = "Account Number is required.";
    }
    if (!bank?.iban) {
      errors.iban = "IBAN is required.";
    }
  }

  setValidationErrors(errors);
  console.log("Object.keys(errors).length",Object.keys(errors).length);
  return Object.keys(errors).length === 0;
};
  const submit = async (event) => {
    event.preventDefault();
   // const form = event.currentTarget;
   console.log("before validation")
   {
      try {
        console.log("after if")
        //if (form?.checkValidity()) 
  
          
          if(paymentGateWays.paymentMethods.includes("cod"))
          {
            paymentGateWays.paymentDetails = paymentGateWays.paymentDetails?.filter(
              detail => detail.paymentType !== "cod"
            );
            paymentGateWays.paymentDetails?.push({
              paymentType: "cod"
            });
          }

          if(paymentGateWays.paymentMethods.includes("banktransfer"))
          {
            const { bankName, accountHolderName, accountNumber, iban } = paymentGateWays;
            paymentGateWays.paymentDetails = paymentGateWays.paymentDetails?.filter(
              detail => detail.paymentType !== "banktransfer"
            );
            paymentGateWays.paymentDetails?.push({
              paymentType: "banktransfer",
              bankName,
              accountHolderName,
              accountNumber,
              iban
            });
          }
          
          if(paymentGateWays.paymentMethods.includes("stripe"))
          {
             // eslint-disable-next-line no-debugger
      debugger;
            const { stripeApiKey, stripeSecretKey } = paymentGateWays;
            const areKeysValid = await verifyStripeKeys(
              stripeApiKey,
              stripeSecretKey
            );
            const stripeDetails = {
              paymentType: "stripe",
              stripeApiKey,
              stripeSecretKey
            };

            if (!areKeysValid) {
              alert("Invalid Stripe API or Secret Key. Please check and try again.");
              //return; // Stop submission if either key is invalid
            }
            paymentGateWays.paymentDetails = paymentGateWays.paymentDetails?.filter(
              detail => detail.paymentType !== "stripe"
            );
            paymentGateWays.paymentDetails?.push(stripeDetails);
          }

          if (validateForm()) 
          {
            delete paymentGateWays.bankName;
            delete paymentGateWays.accountHolderName;
            delete paymentGateWays.accountNumber;
            delete paymentGateWays.iban;
            delete paymentGateWays.stripeApiKey;
            delete paymentGateWays.stripeSecretKey;
           
          try {
            await axios.post("addorupdatestorepaymentconfig/", paymentGateWays);
            MySwal.fire({
              position: "top-end",
              icon: "success",
              title: "Created Successfully!",
              showConfirmButton: false,
              timer: 3000,
              })
          }
          catch(error)
          {
            console.error("Error submitting payment gateway:", error);
            MySwal.fire({
              position: "top-end",
              icon: "error",
              title: error.response.data.message,
              showConfirmButton: false,
              timer: 3000,
            });  
          }
            resetForm();
            closeRef.current?.click();
            dispatch(set_page_refresh("paymentConfigs"));
          }
        
      } catch (error) {
        console.error("Error submitting payment gateway:", error);
        MySwal.fire({
          position: "top-end",
          icon: "error",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }

  };

  return (
    <div className="modal fade" id="add-brand">
      <div className="modal-dialog modal-dialog-centered custom-modal-two modal-xl">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <h4>
                  {Object.keys(data || {}).length
                    ? t?.[l]?.["edit_payment_gateway"] || "Edit Payment Gateway"
                    : t?.[l]?.["add_payment_gateways"] || "Add Payment Gateways"}
                </h4>
                <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body new-employee-field">
                <form onSubmit={submit}>
                  {/* Country Dropdown */}
                  <div className="mb-3">
                    <label className="form-label">
                      {t?.[l]?.["select_a_country_to_populate_its_payment_gateway_options"] || "Select a country to populate its payment gateway options"} <span>*</span>
                    </label>
                    <Select
                      className="select"
                      options={countriesOptions}
                      name="country"
                      value={countriesOptions.find(option => option.value === paymentGateWays.country) || countriesOptions[0]} // Default to the first country option if no match
                      onChange={(selectedOption) => {
                        handleInputChange({ target: { name: "country", value: selectedOption.value } });
                      }}
                    />
                    {validationErrors.country && <p className="text-danger">{validationErrors.country}</p>}
                  </div>
                  {availablePaymentMethods && availablePaymentMethods.includes("cod") &&(
                    <>
                  <div key="cod" className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="checkbox-cod"
                      checked={paymentGateWays.paymentMethods.includes("cod")}
                      onChange={(e) => handleCheckboxChange("cod", e.target.checked)}
                    />
                    <label htmlFor="checkbox-cod" className="form-check-label">
                    {t?.[l]?.["cod"] }
                    </label>
                  </div>
                  <hr />
                  </>
                  )}
                  {/* Conditional Fields for Bank Transfer and Stripe */}

                {availablePaymentMethods && availablePaymentMethods.includes("banktransfer") &&(
                  <>
                  <div key="banktransfer" className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={showBankFields && paymentGateWays.paymentMethods.includes("banktransfer")}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setShowBankFields(isChecked); // Update showBankFields state
                        handleCheckboxChange("banktransfer", isChecked); // Update paymentMethods
                      }}
                    />
                    <label htmlFor="checkbox-banktransfer" className="form-check-label">
                    {t?.[l]?.["banktransfer"] }
                    </label>
                  </div>
                  <hr />       
                    {showBankFields && paymentGateWays.paymentMethods.includes("banktransfer") && (
                      <>
                    <div className="d-flex flex-wrap">
                      <div className="mb-3 me-3">
                        <label className="form-label">Bank Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="bankName"
                          value={paymentGateWays.bankName}
                          maxLength={100}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.bankName && <p className="text-danger">{validationErrors.bankName}</p>}
           
                      </div>
                      <div className="mb-3 me-3">
                        <label className="form-label">Account Holder Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="accountHolderName"
                          value={paymentGateWays.accountHolderName}
                          maxLength={100}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.accountHolderName && <p className="text-danger">{validationErrors.accountHolderName}</p>}
           
                      </div>
                      <div className="mb-3 me-3">
                        <label className="form-label">Account Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="accountNumber"
                          value={paymentGateWays.accountNumber}
                          maxLength={30}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.accountNumber && <p className="text-danger">{validationErrors.accountNumber}</p>}
           
                      </div>
                      <div className="mb-3 me-3">
                        <label className="form-label">IBAN</label>
                        <input
                          type="text"
                          className="form-control"
                          name="iban"
                          value={paymentGateWays.iban}
                          onChange={handleInputChange}
                          maxLength={30}
                          
                        />
                          {validationErrors.iban && <p className="text-danger">{validationErrors.iban}</p>}
         
                      </div>
                     
                    </div>
                    <hr />
                     </>
                  )} 
                 
                  </>
                )}
                  {availablePaymentMethods && availablePaymentMethods.includes("stripe") &&(
                  <>
                  <div key="stripe" className="form-check">
                    <input
                    type="checkbox"
                    className="form-check-input"
                    checked={showStripeFields || paymentGateWays.paymentMethods.includes("stripe")}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setShowStripeFields(isChecked); // Update showBankFields state
                        handleCheckboxChange("stripe", isChecked); // Update paymentMethods
                      }}                  
                    />
                   
                    <label htmlFor="checkbox-stripe" className="form-check-label">
                    {t?.[l]?.["stripe"] }
                    </label>
                  </div>
                  <hr />
                  {/* {paymentGateWays.paymentMethod === "stripe" && ( */}
                  {showStripeFields && (
                    <div className="d-flex flex-wrap">
                      <div className="mb-3 me-2">
                        <label className="form-label">Stripe API Key</label>
                        <input
                          type="text"
                          className="form-control"
                          name="stripeApiKey"
                          value={paymentGateWays.stripeApiKey}
                          onChange={handleInputChange}
                          maxLength={200}
                          
                        />
                           {validationErrors.stripeApiKey && <p className="text-danger">{validationErrors.stripeApiKey}</p>}
        
                      </div>
                      <div className="mb-3 me-2">
                        <label className="form-label">Stripe Secret Key</label>
                        <input
                          type="text"
                          className="form-control"
                          name="stripeSecretKey"
                          value={paymentGateWays.stripeSecretKey}
                          onChange={handleInputChange}
                          maxLength={200}
                          
                        />
                        {validationErrors.stripeSecretKey && <p className="text-danger">{validationErrors.stripeSecretKey}</p>}
       
                      </div>
                      <hr />
                    </div>
                  )}
                  
                  </>
                )}
                  {/* Store Dropdown */}
                  <div className="mb-3">
                    <label className="form-label">
                      {t?.[l]?.["store"] || "Store"} <span>*</span>
                    </label>

                    <Select
                      className="select"
                      options={storeOptions}
                      name="storeId"
                      isMulti
                      placeholder="Select Store" // or any dynamic placeholder like {chooseStore}
                      value={paymentGateWays.stores.map(store => ({
                        value: store.storeId,
                        label: store.storeName,
                      }))}
                      onChange={(e) => handleInputChange({ target: { name: 'storeId', value: e.map(store => store.value) } })}
                    
                    />
                       {validationErrors.stores && <p className="text-danger">{validationErrors.stores}</p>}
                     
                  </div>
                  <div className="modal-footer-btn">
                     <button type="button" className="btn btn-cancel me-2" data-bs-dismiss="modal" ref={closeRef}>{t?.[l]?.["cancel"] || "Cancel"}</button>
                     <button type="submit" className="btn btn-submit">{t?.[l]?.["save"] || "Save"}</button>
                   </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPaymentGateWays;